import api from '@/api';

import { API_BASE_URL } from '..';
import {
  ReportConsumablesParams,
  ReportGroupsParams,
  ReportInventoryParams,
  ReportManufacturersParams,
  ReportMinimumStockParams,
  ReportPartsParams,
  ReportPlanAccountParams,
} from './Report.types';

const baseUrl = API_BASE_URL;

export async function generateManufacturersReport(
  params?: ReportManufacturersParams,
) {
  const result = (await api.getReport(
    `${baseUrl}/generate/manufacturers`,
    params,
  )) as unknown;

  return result as BlobPart;
}

export async function generatePartsReport(params?: ReportPartsParams) {
  const result = (await api.getReport(
    `${baseUrl}/generate/parts`,
    params,
  )) as unknown;

  return result as BlobPart;
}

export async function generateGroupsReport(params?: ReportGroupsParams) {
  const result = (await api.getReport(
    `${baseUrl}/generate/groups`,
    params,
  )) as unknown;

  return result as BlobPart;
}

export async function generatePlanAccountReport(
  params?: ReportPlanAccountParams,
) {
  const result = (await api.getReport(
    `${baseUrl}/generate/plan-accounts`,
    params,
  )) as unknown;

  return result as BlobPart;
}

export async function generateConsumablesReport(
  params?: ReportConsumablesParams,
) {
  const result = (await api.getReport(
    `${baseUrl}/generate/consumables`,
    params,
  )) as unknown;

  return result as BlobPart;
}

export async function generateMinimumStockReport(
  params?: ReportMinimumStockParams,
) {
  const result = (await api.getReport(
    `${baseUrl}/generate/minimumStock`,
    params,
  )) as unknown;

  return result as BlobPart;
}

export async function generateInventoryReport(params?: ReportInventoryParams) {
  const result = (await api.getReport(
    `${baseUrl}/generate/inventory`,
    params,
  )) as unknown;

  return result as BlobPart;
}
